"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var SIX_MONTHS_IN_MILLISECONDS = 6 * 30 * 24 * 60 * 60 * 1000;
var utils = {
  getTokenExpiryTimeAsGMTString: function getTokenExpiryTimeAsGMTString(token) {
    return new Date((0, _jwtDecode["default"])(token).exp * 1000 + SIX_MONTHS_IN_MILLISECONDS).toGMTString();
  },
  isExpired: function isExpired(token) {
    return !token || new Date((0, _jwtDecode["default"])(token).exp * 1000).getTime() <= new Date().getTime();
  },
  getDecodedToken: function getDecodedToken(token) {
    return (0, _jwtDecode["default"])(token);
  }
};
module.exports = utils;